import styled from "styled-components";
import { Link } from "react-router-dom";

//components
import LazyLoadImg from "core/LazyLoadImg";
import BodyText from "core/BodyText";

//styles
import { BorderBottomLinkStyle } from "core/Typography";

export const MoreFromThisTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: flex-start;
    align-items: flex-start;

    @media (min-width: 48rem) {
        margin-right: 1.25rem;
    }
`;

export const RowHeading = styled(BodyText)`
    width: 5.875rem; /* 94px */
    height: 3.125rem; /* 50px */
`;

export const ViewAllLink = styled(Link)`
    ${BorderBottomLinkStyle}
`;

export const ImageRowWrapper = styled.div`
    display: inline-block;
    width: 100%;
`;

export const ImageRow = styled.div`
    height: 4.375rem; /* 70px */
    overflow-y: hidden;

    ${LazyLoadImg} {
        display: inline-block;
        height: 4.375rem; /* 70px */
        margin-right: 1rem; /* 16px */
    }

    img {
        height: 100%;
        width: auto;
    }
`;
